import PDFNavigationBarContainer from './PDFNavigationBarContainer';

export default PDFNavigationBarContainer;
